import type { ReactElement } from "react";
import { ChevronRight } from "@tamagui/lucide-icons";
import { Paragraph2, XStack, YStack } from "@medbillai/ui";
export type GetHelpPromptProps = {
  title: string;
  description: string;
  badge: ReactElement;
  onPress: () => void;
  labelBadge?: ReactElement;
  testID?: string;
};
export function GetHelpPrompt({
  title,
  description,
  badge,
  labelBadge,
  onPress,
  testID
}: GetHelpPromptProps) {
  return <XStack testID={testID} onPress={onPress} gap="$sp2" py="$sp1.5" pl="$sp2.5" pr="$sp2" alignItems="center" hoverStyle={{
    backgroundColor: "$surface1Hover"
  }} pressStyle={{
    backgroundColor: "$surface1Hover"
  }} cursor="pointer" data-sentry-element="XStack" data-sentry-component="GetHelpPrompt" data-sentry-source-file="GetHelpPrompt.tsx">
      {badge}

      <YStack flex={1} gap="$1" data-sentry-element="YStack" data-sentry-source-file="GetHelpPrompt.tsx">
        <XStack gap="$2" data-sentry-element="XStack" data-sentry-source-file="GetHelpPrompt.tsx">
          <Paragraph2 color="$textDefault" bold data-sentry-element="Paragraph2" data-sentry-source-file="GetHelpPrompt.tsx">
            {title}
          </Paragraph2>
          {labelBadge}
        </XStack>
        <Paragraph2 color="$textSubtle" data-sentry-element="Paragraph2" data-sentry-source-file="GetHelpPrompt.tsx">{description}</Paragraph2>
      </YStack>

      <ChevronRight size={24} color="$cream10" data-sentry-element="ChevronRight" data-sentry-source-file="GetHelpPrompt.tsx" />
    </XStack>;
}